import JobDescriptionListContainer from "./JobDescriptionListContainer";
export default JobDescriptionListContainer;
